document.addEventListener("DOMContentLoaded", () => {
  const selectors = {
    slider: "#product-container.swiper-container",
    mediaItem: "[data-media-id]",
    thumbsContainer: ".swiper-thumbs",
    thumbItem: "#product-thumb.swiper-slide", // Ensure this matches your actual class
  };


  const sliderElement = document.querySelector(selectors.slider);
  const thumbsContainer = document.querySelector(selectors.thumbsContainer);

  if (!sliderElement || !thumbsContainer) return;

  // Initialize Swipers
  const thumbsInstance = new Swiper(thumbsContainer, {
    slidesPerView: "auto",
    spaceBetween: 6,
    // centeredSlides: true,
    // centeredSlidesBounds: true,
    initialSlide: 0,
    freeMode: false,
    // watchSlidesVisibility: true,
    watchSlidesProgress: true,
    navigation: {
      nextEl: "#product-thumb-next",
      prevEl: "#product-thumb-prev",
    },
  });

  const sliderInstance = new Swiper(sliderElement, {
    navigation: false,
    spaceBetween: 10,
    centeredSlides: true,
    watchOverflow: true,
    initialSlide: 0,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    preventInteractionOnTransition: true,
    slidesPerView: 1,
    thumbs: {
      swiper: thumbsInstance,
    },
  });

  // Add click events for thumbnails
  const thumbElements = document.querySelectorAll(selectors.thumbItem);



  if (thumbElements.length === 0) {
    console.log("No thumbnail elements found");
  }

  thumbElements.forEach((thumb) => {
    thumb.onclick = (event) => {
      const mediaId = Number(event.currentTarget.dataset.mediaId);
      setActiveMedia(mediaId);
    };
  });

  function setActiveMedia(id) {
    const mediaFound = Array.from(
      document.querySelectorAll(selectors.mediaItem)
    ).find((media) => Number(media.dataset.mediaId) === id);

    if (!mediaFound) return;

    sliderInstance.slideTo(Number(mediaFound.dataset.index));
  }
});
